export default {
  computed: {
    page: {
      get() {
        var page = 1;
        try {
          page = this.$route.query.p ? parseInt(this.$route.query.p) : 1;
        } catch (e) {
        }

        return page;
      },
      set() {

      }
    },
    list() {
      return this.items ? this.items[this.page] : [];
    },
  },
  methods: {
    changePage(pageNum) {
      this.$router.push({
        name: this.routeName,
        query: { p: pageNum }
      });
    },
  },
  beforeRouteUpdate(to, f, next) {
    if (to.name === this.routeName) {
      if (this.loadContent) {
        this.loadContent(to.query.p)
           .then(() => {
              this.$wait.end(this.loaderName);
              next();
          });
      } else {
        next();
      }
    } else {
      next();
    }
  }
};
